import { BRAND } from "@/lib/brand";
import { BrandLogo } from "@/components/site/BrandLogo";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[color:var(--rule)] bg-[color:var(--ivory-2)] py-20 text-[color:var(--ink)] sm:py-24"
    >
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <BrandLogo className="h-10 sm:h-12" tone="ink" testId="footer-logo" />
            <p className="font-display mt-6 max-w-md text-xl leading-snug text-[color:var(--ink)]">
              {t.footer.tag_a}{" "}
              <span className="font-serif-accent italic text-[color:var(--emerald)]">
                {t.footer.tag_b}
              </span>
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[color:var(--ink-3)]">
              {t.footer.sub}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono-accent mb-4 text-xs uppercase tracking-[0.22em] text-[color:var(--emerald)]">
              {t.footer.cols.about}
            </h4>
            <ul className="space-y-3 text-sm text-[color:var(--ink-2)]">
              <li>
                <a
                  href="#about"
                  className="transition-colors hover:text-[color:var(--emerald)]"
                >
                  {t.footer.cols.links.about}
                </a>
              </li>
              <li>
                <a
                  href="#process"
                  className="transition-colors hover:text-[color:var(--emerald)]"
                >
                  {t.footer.cols.links.approach}
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="transition-colors hover:text-[color:var(--emerald)]"
                >
                  {t.footer.cols.links.contact}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono-accent mb-4 text-xs uppercase tracking-[0.22em] text-[color:var(--emerald)]">
              {t.footer.cols.practices}
            </h4>
            <ul className="space-y-3 text-sm text-[color:var(--ink-2)]">
              {t.footer.practices.map((p) => (
                <li key={p}>
                  <a
                    href="#capabilities"
                    className="transition-colors hover:text-[color:var(--emerald)]"
                  >
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-accent mb-4 text-xs uppercase tracking-[0.22em] text-[color:var(--emerald)]">
              {t.footer.cols.contact}
            </h4>
            <ul className="space-y-3 text-sm text-[color:var(--ink-2)]">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  data-testid="footer-email"
                  className="font-medium transition-colors hover:text-[color:var(--emerald)]"
                >
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-[color:var(--emerald)]"
                >
                  LinkedIn ↗
                </a>
              </li>
              <li>
                <a
                  href={BRAND.social.x}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-[color:var(--emerald)]"
                >
                  X / Twitter ↗
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-[color:var(--rule)] pt-8 text-xs text-[color:var(--muted)] sm:flex-row sm:items-center">
          <span className="font-mono-accent uppercase tracking-[0.22em]">
            © {year} Delhigence.AI — {t.footer.rights}
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-[color:var(--emerald)]/30 bg-[color:var(--emerald)]/[0.06] px-3 py-1 text-[color:var(--emerald)]">
            <span className="font-mono-accent text-[10px] uppercase tracking-[0.22em]">
              {t.footer.poweredBy}
            </span>
            <img
              src="/emergent-logo.svg"
              alt="Emergent"
              className="h-3 w-auto"
              draggable={false}
            />
          </span>
        </div>
      </div>
    </footer>
  );
};
